export function buildContractFilter({
    referenceFilter = '',
    identifierFilter = '',
    reconductionFilter = '',
    paymentStatusFilter = '',
    startDate = null,
    endDate = null,
    }) {

    const filters = [];
    const currentTime = new Date().toISOString().split('T')[0];

    if (referenceFilter.trim()) {
        filters.push(`(df.reference:like:'%${referenceFilter.trim()}%')`);
    }

    if (identifierFilter.trim()) {
        filters.push(`(s.siret LIKE '${identifierFilter.trim()}%' OR s.siren LIKE '${identifierFilter.trim()}%')`);
    }

    if (reconductionFilter) {
        let reconductionCondition;
        switch (reconductionFilter) {
            case 'arret':
                reconductionCondition = `(df.taciteReconduction=0)`;
                break;
            case 'reconduit':
                reconductionCondition = `(df.taciteReconduction=1 AND df.date_fin<'${currentTime}')`;
                break;
            case 'reconductible':
                reconductionCondition = `(df.taciteReconduction=1 AND df.date_fin>'${currentTime}')`;
                break;
            default:
                reconductionCondition = null;
        }

        if (reconductionCondition) {
            filters.push(reconductionCondition);
        }
    }

    if (paymentStatusFilter) {
        filters.push(`(df.incident_paiement:=:${paymentStatusFilter})`);
    }

    if (startDate && startDate.length === 2) {
        const start = startDate[0].toLocaleDateString('en-ZA');
        const end = startDate[1].toLocaleDateString('en-ZA');
        filters.push(`(df.date_debut:>=:'${start}') and (df.date_debut:<=:'${end}')`);
    }

    if (endDate && endDate.length === 2) {
        const start = endDate[0].toLocaleDateString('en-ZA');
        const end = endDate[1].toLocaleDateString('en-ZA');
        filters.push(`(df.date_fin:>=:'${start}') and (df.date_fin:<=:'${end}')`);
    }

    return filters.join(' and ');
}